












import Vue from 'vue';
import Component from 'vue-class-component';
import i18n from './i18n';

const IconPlay = () => import('../../icons/play.svg');

const PlayOnYoutubeProps = Vue.extend({
  props: {
    videoLength: String,
  },
});

@Component({
  components: {
    IconPlay,
  },
  i18n,
})
export default class PlayOnYoutubeButton extends PlayOnYoutubeProps {

}
